import {
  getBeefCutsCRM, importBeefCutsCRM, getBeefCutsContent,
  importBeefCutsResearch, addBeefCutsContent, backendPublishCutsComment,
  backendUploadEstBrochure, getBackendEstBrochure, backendPublishEstBrochure,
  getBackendEstBrochureByUserID, addBeefCutsContentData, getCutsComment,
  getNameSpaceBackend, addNameSpaceBackend, deleteNameSpaceBackend,
  setDefaultCutsBrochure, backendDeleteEstBrochure, uploadBackgroundCirclePicture, addBeefBackgroundCutsContent, getBackgroundCutsComment
} from '@/api/cuts'

const cuts = {
  state: {
    total: 0,
    rows: [],
    row: {},
    datas: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_DATAS: (state, datas) => {
      state.datas = datas
    }
  },
  actions: {
    GetBeefCutsCRM({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefCutsCRM(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImportBeefCutsCRM({ commit }, params) {
      return new Promise((resolve, reject) => {
        importBeefCutsCRM(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefCutsContent({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefCutsContent(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_DATAS', response.Data.Datas)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImportBeefCutsResearch({ commit }, params) {
      return new Promise((resolve, reject) => {
        importBeefCutsResearch(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddBeefCutsContent({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBeefCutsContent(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    BackendPublishCutsComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        backendPublishCutsComment(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    BackendUploadEstBrochure({ commit }, params) {
      return new Promise((resolve, reject) => {
        backendUploadEstBrochure(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBackendEstBrochure({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendEstBrochure(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    BackendPublishEstBrochure({ commit }, params) {
      return new Promise((resolve, reject) => {
        backendPublishEstBrochure(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBackendEstBrochureByUserID({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendEstBrochureByUserID(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddBeefCutsContentData({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBeefCutsContentData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetCutsComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCutsComment(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetNameSpaceBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        getNameSpaceBackend(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddNameSpaceBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        addNameSpaceBackend(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteNameSpaceBackend({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteNameSpaceBackend(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetDefaultCutsBrochure({ commit }, params) {
      return new Promise((resolve, reject) => {
        setDefaultCutsBrochure(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    BackendDeleteEstBrochure({ commit }, params) {
      return new Promise((resolve, reject) => {
        backendDeleteEstBrochure(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UploadBackgroundCirclePicture({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadBackgroundCirclePicture(params).then((response) => {
          commit('SET_DATAS', response.Data.Datas)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddBeefBackgroundCutsContent({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBeefBackgroundCutsContent(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBackgroundCutsComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackgroundCutsComment(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default cuts



// WEBPACK FOOTER //
// ./src/store/modules/cuts.js